import React from 'react';
import { Clock, FlaskConical } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

// Reading-time + methodology/sources meta shown on knowledge pages.
export const ReadingMeta = ({ minutes }) => {
  const { t } = useLang();
  return (
    <span className="inline-flex items-center gap-1.5 text-[12.5px] font-medium text-slate-500">
      <Clock className="w-3.5 h-3.5" />
      {minutes} {t('common.readingTime')}
    </span>
  );
};

// Sources & methodology block placed at the end of technical pages.
export const SourcesBlock = ({ sources = [] }) => {
  const { t } = useLang();
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-6">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-3">
        <FlaskConical className="w-3.5 h-3.5" /> {t('common.sources')}
      </p>
      <ul className="space-y-2 text-[13px] text-slate-600 leading-relaxed list-disc pl-4">
        {sources.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>
    </div>
  );
};
